<template>
  <div class="container">
    <img
      :src="item.TGS_PICLIST"
      alt=""
      v-for="(item, index) in list"
      :key="index"
      class="img"
      @click="go(item)"
    />
  </div>
</template>


<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.$axios
      .postReq("/meide/REST/ajaxMdIndex", {
        postType: "queryshoppinglist",
      })
      .then((res) => {
        this.list = res.items;
      });
  },
  methods: {
    go(item) {
      let TGS_ID = item.TGS_ID;
      this.$router.push({
        name: "GoodsList",
        query: {
          TGS_ID,
          type: "oneStopList",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.img {
  width: 1200px;
  height: 275px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>

